import {
  CustomLink_LinkType,
  CustomLink_LinkType_index,
} from '@weave/schema-gen-ts/dist/schemas/brand-settings/v1/settings.pb';

export type CustomLinkWithIdAndLabels = Record<
  CustomLink_LinkType,
  {
    id: CustomLink_LinkType;
    label: string;
  }
>;

export type LinkDetails = { id: CustomLink_LinkType_index; label: string };

export type SocialLinkDetails = null | { url: string; platformName?: string };

export type BrandingModal_CustomLink = {
  locationIds: string[];
  type: CustomLink_LinkType;
  url: string;
};

export type BrandingModal_CustomSocialLink = {
  locationIds: string[];
  platformName?: string;
  url: string;
};

export type BrandingModal_Logo = {
  locationIds: string[];
  logoUrl: string;
};

export type BrandingModal_SocialLinkType = 'facebookMapping' | 'googleMapping' | 'custom';

export type BrandingModal_SocialLink = {
  locationIds?: string[];
  type: BrandingModal_SocialLinkType;
};

export enum SocialLinkType {
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE',
  CUSTOM = 'CUSTOM_LINK',
}

export type SocialLinksWithIdAndLabels = Record<
  string,
  {
    id: SocialLinkType;
    label: string;
  }
>;

export type SocialLink = {
  address?: string;
  name?: string;
  platformName?: string;
  type: SocialLinkType;
  url?: string;
};

export type LinkActionType = {
  type: 'edit' | 'delete';
  callback: (id: string) => void;
};
